import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import '../base/Theme.css';
import './Register.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import Input from "../base/input/Input";
import Button from "../base/button/Button";
import Note from "../base/note/Note";
import Loader from "../base/loader/Loader";
import {register} from "../../data/Api";
import Toolbar from "../base/toolbar/Toolbar";
import {showError, showSuccess} from "../base/toaster/CustomToaster";
import Space from "../base/space/Space";
import Back from "../base/back/Back";

function Register() {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [loading, setLoading] = useState(true);

    let stopAuthListener;

    useEffect(() => {
        checkLogin();
    }, [])

    const checkLogin = () => {
        setLoading(true);
        stopAuthListener = firebase.auth().onAuthStateChanged(function (user) {
            if (user) history.replace("/lobby");
            setLoading(false);

            stopAuthListener();
        });
    }

    const onEmailChanged = (email) => {
        setEmail(email);
    }

    const onNameChanged = (name) => {
        setName(name);
    }

    const onPass1Changed = (password) => {
        setPassword1(password);
    }

    const onPass2Changed = (password) => {
        setPassword2(password);
    }

    const onRegisterClick = async () => {
        if (password1 !== password2) {
            showError("Passwords does not match.");
            return;
        }
        if (!name?.trim()) {
            showError("Name is required.");
            return;
        }

        try {
            setLoading(true)

            const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, password1);
            await register(email, name);
            await userCredential.user.sendEmailVerification();
            await firebase.auth().signOut()

            showSuccess("Check your inbox. We've sent you an verification email.")

            setLoading(false);
            history.replace("/login");
        } catch (e) {
            showError(e.message);
            setLoading(false);
        }
    }

    const onTermsClick = () => {
        history.push("/terms");
    }

    if (loading) {
        return <div className={"Root"}><Loader/></div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Sign up"} leftButton={<Back/>}/>
                <Input type="text" placeholder={"Name"} text={name} onTextChanged={onNameChanged}
                       onEnterPressed={onRegisterClick}/>
                <Space space={8}/>
                <Input type="text" placeholder={"Email"} text={email} onTextChanged={onEmailChanged}
                       onEnterPressed={onRegisterClick}/>
                <Space space={8}/>
                <Input type="password" placeholder={"Password"} text={password1} onTextChanged={onPass1Changed}
                       onEnterPressed={onRegisterClick}/>
                <Space space={8}/>
                <Input type="password" placeholder={"Repeat password"} text={password2} onTextChanged={onPass2Changed}
                       onEnterPressed={onRegisterClick}/>
                <Space space={32}/>
                <Button text={"Sign up"} onClick={onRegisterClick}/>
                <Space space={16}/>
                <Note text={"By signing up you agree to our"} link={"Terms of Service"} onClick={onTermsClick}/>
            </div>
        </div>
    );
}

export default Register;
